/** @jsxImportSource @emotion/react */
import Step, { type IStepProps } from 'modules/main/ui/components/stepper/components/step/step';
import React from 'react';
import { useCollapsibleAnimationStyles } from 'shared/utils';
import type { DivProps } from 'typings';
import { ClickableArea } from 'ud-ui/components';
import EmptyButton from 'ud-ui/components/empty-button';
import ArrowDashIcon from 'ud-ui/components/icon/arrow-dash-icon';
import CloseIcon from 'ud-ui/components/icon/close-icon';
import Text from 'ud-ui/components/text';
import * as S from './styles';

interface IProps extends DivProps {
  header: string;
  subtitle?: string;
  onClose?: () => void;
  isOpened: boolean;
  steps: IStepProps[];
}

function Stepper(props: IProps) {
  const { ...rest } = props;

  const { ref, styles } = useCollapsibleAnimationStyles({
    isOpen: props.isOpened,
    maxHeight: '309px',
    additionalStyles: { closed: { padding: 0 }, open: { paddingTop: '28px' } },
    exitStyles: { display: 'none' },
  });

  return (
    <S.MainBlock {...rest} ref={ref} style={styles}>
      <S.CloseBlock>
        <EmptyButton
          onClick={props.onClose}
          icon={
            <ClickableArea horizontalExtend={10} verticalExtend={10}>
              <CloseIcon />
            </ClickableArea>
          }
        />
      </S.CloseBlock>
      <S.Header className="mb-13">
        <Text isNew type="title-1">
          {props.header}
        </Text>
        {props.subtitle && (
          <Text isNew type="body-2">
            {props.subtitle}
          </Text>
        )}
      </S.Header>
      <S.Steps>
        {props.steps.map((step, index) => (
          <>
            <Step {...step} key={step.emoji?.toString() ?? index} />
            {index !== props.steps.length - 1 && <ArrowDashIcon id={`icon-${index}`} />}
          </>
        ))}
      </S.Steps>
    </S.MainBlock>
  );
}

export default Stepper;
